angular.module('app.entity.audit').filter('historyAction', [
    'gettext',
    'STRATEGY_CHANGE_ACTIONS',
    function historyActionFilterFactory(gettext, STRATEGY_CHANGE_ACTIONS) {
        /**
         * Devuelve la descripción de la acción correspondiente a un cambio
         *
         * @param  {object} change Cambio completo proveniente del audit
         *
         * @return {string}        Etiqueta descriptiva de la acción
         */
        return function historyActionFilter(change) {
            switch (change.action) {
                case 'modify-data':
                    return gettext('Dato modificado');

                case 'delete-item':
                    return gettext('Elemento en lista eliminado');

                case 'add-item':
                    return gettext('Nuevo elemento en lista');

                case 'create-record':
                    return gettext('Registro creado');

                case 'add-data':
                    return gettext('Dato añadido');

                case 'import-record':
                    return gettext('Importado desde fichero');

                case 'import-update-record':
                    return gettext('Actualizado desde fichero');

                case 'form-metadata':
                    return gettext('Formulario actualizado');

                case 'global-metadata':
                    return gettext('Registro actualizado');

                case 'record-uid':
                    return gettext('Identificador modificado');

                case 'store-record':
                    return gettext('Registro archivado');

                case 'delete':
                    // acción de 1.x cuando se eliminaba el valor de un dato
                    return gettext('Dato eliminado');

                case 'update-status':
                    return gettext('Estado actualizado');

                case STRATEGY_CHANGE_ACTIONS.SET_REVISION_STRATEGY:
                    return gettext('Estrategia SDV establecida');

                case STRATEGY_CHANGE_ACTIONS.UPDATE_REVISION_STRATEGY:
                    return gettext('Estrategia SDV actualizada');

                default:
                    return change.action;
            }
        };
    }]);
